import { css } from 'styled-system/css';

export const accountManageStyles = {
	wrap: css({
		display: 'flex',
		flexDirection: 'column',
		overflow: 'hidden',
		justifyContent: 'flex-start',
		w: '100%',
		md: {
			gap: '12px',
		}
	}),
	divider: css({
		backgroundColor: 'jupiter.grey.divider',
		height: '1px',
		width: '100%',
		border: 'none',
	}),
	section: css({
		display: 'flex',
		width: '100%',
		flexDirection: 'column',
		justifyContent: 'flex-start',
	}),
	paymentMethodSection: css({
		display: 'none',
		marginTop: '12px',
		width: '100%',
		maxWidth: '1178px',
		flexDirection: 'column',
		justifyContent: 'flex-start',

		md: {
			display: 'flex',
		}
	}),
	paymentMethodTitle: css({
		borderLeft: '5px solid {colors.jupiter.main.primary}',
		width: '100%',
		padding: '6px 12px',
		color: 'jupiter.grey.90',
		whiteSpace: 'nowrap',
		textAlign: 'left',
		fontSize: '16px',
		fontWeight: '700',
		lineHeight: '18px',
		mb: '12px'
	}),
	bankImgWrap: css({
		w: '100px',
		h: '75px',
		position: 'relative',
		userSelect: 'none'
	}),
	bankTabItem: css({
		borderRadius: '6px',
		border: '1px solid',
		borderColor: 'jupiter.grey.40',
		bgColor: 'jupiter.grey.10',
		alignSelf: 'stretch',
		zIndex: '0',
		display: 'flex',
		padding: '6px 12px',
		flexDirection: 'column',
		color: 'jupiter.grey.70',
		textAlign: 'center',
		justifyContent: 'flex-start',
		gap: '6px',
		width: '124px',
		fontSize: '14px',
		fontWeight: '500',
		cursor: 'pointer',
		flex: '0 0 auto',
		position: 'relative',
	}),
	bankTabItemActive: css({
		borderColor: 'jupiter.main.primary',
		color: 'jupiter.main.primary',
	}),
	depositForm: css({
		display: 'flex',
		width: '100%',
		padding: '12px',
		flexDirection: 'column',
		justifyContent: 'flex-start',
		gap: '12px',
		bgColor: 'jupiter.grey.10',
		borderRadius: '6px',
		marginTop: '0px',

		md: {
			marginTop: '12px',
		}
	}),
	pendingForm: css({
		display: 'flex',
		width: '100%',
		px: '12px',
		py: '12px 0',
		flexDirection: 'column',
		justifyContent: 'flex-start',
		gap: '24px',
		bgColor: 'jupiter.grey.10',
		borderRadius: '6px',
		marginTop: '0px',

		md: {
			marginTop: '12px',
		}
	}),
	customText: css({
		display: 'flex',
		p: '6px',
		bgColor: 'jupiter.grey.30',
		alignItems: 'center',
		color: 'jupiter.grey.70',
		fontSize: '14px',
		fontWeight: '500',
		borderRadius: '6px',
	}),
	showInDesktop: css({
		display: 'none',
		md: {
			display: 'block',
		}
	}),
	showInMobile: css({
		display: 'block',
		md: {
			display: 'none',
		}
	}),
	statusTitle: css({
		lineHeight: '18px',
		fontSize: '14px',
		fontWeight: '400',
		color: 'jupiter.grey.70'
	}),
	statusContent: css({
		minH: '28px',
		display: 'flex',
		alignItems: 'center',
		gap: '12px',
		justifyContent: 'space-between',
		md: {
			justifyContent: 'flex-start',
		}
	}),
	statusText: css({
		fontSize: '16px',
		fontWeight: '700',
		lineHeight: '18px',
		color: 'jupiter.grey.90'
	}),
	refreshButton: css({
		h: '28px',
		w: '28px',
		_active: {
			'& .icon--refresh': {
				animation: 'loading 1s infinite linear',
			}
		}
	}),
	formSection: css({
		display: 'flex',
		flexDirection: 'column',
		gap: '12px',
		w: '100%',
		maxW: 'unset',
		m: '0 auto',
		md: {
			maxW: '700px',
		}
	}),
	formGroup: css({
		display: 'flex',
		flexDirection: 'column',
		gap: '12px',
	}),
	buttonGroup: css({
		display: 'flex',
		flexDir: 'column',
		w: '100%',
		gap: '12px',
		mb: '24px',
		mt: '12px',
		md: {
			flexDir: 'row',
			justifyContent: 'center',
			gap: '60px',
			
		}
	}),
	cancelButton: css({
		w: '100%',
		borderRadius: '6px',
		minHeight: '36px',
		padding: '0 6px',
		fontSize: '14px',
		cursor: 'pointer',
		borderWidth: '1px',
		borderStyle: 'solid',
		order: 2,
		md: {
			maxW: '270px',
			order: 1,
		}
	}),
	submitButton: css({
		w: '100%',
		borderRadius: '6px',
		minHeight: '36px',
		padding: '0 6px',
		fontSize: '14px',
		fontWeight: '700',
		border: 'none',
		cursor: 'pointer',
		order: 1,
		transition: 'background-color .3s ease-in-out',
		md: {
			maxW: '270px',
			order: 2,
		}
	}),
	checkMessage: css({
		borderRadius: '3px',
		display: 'flex',
		alignItems: 'flex-start',
		gap: '6px',
		color: 'jupiter.grey.70',
		justifyContent: 'flex-start',
		flexWrap: 'wrap',
		py: '6px',
		fontWeight: 500,
		fontSize: '14px',
		lineHeight: '18px',
		cursor: 'pointer',
	}),
	checkIcon: css({
		aspectRatio: 1,
		objectFit: 'contain',
		objectPosition: 'center',
		width: '24px',
		fill: 'jupiter.grey.60',
	}),
	messageContent: css({
		flex: 1,
		flexBasis: '0%',
		m: 0,
		fill: 'jupiter.grey.70',
	}),
	currentText: css({
		color: 'jupiter.main.primary',
		fontSize: '14px',
		fontWeight: '700',
		display: 'flex',
		alignItems: 'center',

		md: {
			height: '36px'
		}
	}),
	loadingIcon: css({
		w: '24px',
		h: '24px',
	}),
};